var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9634 0.529999C20.1081 2.41984 19.5105 4.29167 18.2973 5.74797C17.7164 6.47046 16.9792 7.05173 16.1411 7.448C15.303 7.84426 14.3859 8.04519 13.4589 8.03565C13.3997 7.12684 13.5203 6.21529 13.8136 5.35311C14.107 4.49092 14.5674 3.69501 15.1685 3.01086C16.398 1.61044 18.11 0.724658 19.9634 0.529999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3441 14.2848C22.7282 15.3699 22.3968 16.5933 22.3807 17.841C22.3822 19.2445 22.7969 20.6164 23.5729 21.7859C24.3489 22.9553 25.452 23.8704 26.7446 24.4171C26.2364 26.0681 25.4703 27.6283 24.4748 29.04C23.1378 31.0399 21.736 32.9938 19.5111 33.0299C18.4529 33.0544 17.7386 32.7501 16.9944 32.433C16.218 32.1023 15.409 31.7577 14.1431 31.7577C12.8005 31.7577 11.9553 32.1134 11.1401 32.4565C10.4356 32.7529 9.75359 33.04 8.7924 33.0798C6.67351 33.1583 5.05418 30.9453 3.66861 28.9641C0.899247 24.9181 -1.25716 17.5618 1.63381 12.5564C2.30121 11.3571 3.2679 10.3511 4.43968 9.63652C5.61146 8.9219 6.94837 8.52299 8.32015 8.47867C9.5219 8.45395 10.6751 8.91713 11.6861 9.32322C12.4592 9.63378 13.1493 9.91095 13.7143 9.91095C14.2111 9.91095 14.8818 9.64473 15.6636 9.33446C16.895 8.84572 18.4018 8.2477 19.9373 8.40888C21.114 8.4457 22.266 8.75639 23.3016 9.31629C24.3373 9.87619 25.2282 10.6699 25.9035 11.6343C24.8405 12.2878 23.9601 13.1996 23.3441 14.2848Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.ad01b17adc1f45e07d60700e9ce30add.svg";
export { ForwardRef as ReactComponent };